// extracted by mini-css-extract-plugin
export default {"imageWrapper":"eE-z","hovered":"fE-z","hoverImage":"gE-z","mainImage":"hE-z","imageNoBackground":"iE-z","fullSizeImage":"jE-z"};